import { render, staticRenderFns } from "./default.vue?vue&type=template&id=e0a45fa0&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/northbankcm/public_html/frontend/components/AppHeader.vue').default,SchemaFooter: require('/home/northbankcm/public_html/frontend/components/modules/SchemaFooter.vue').default})
